module.exports = __webpack_public_path__ + "img/Nikol-omne.b7f72ffa.jpg";